import { ADD_FEATURE_FLAGS } from "../actions/featureFlag.action";
import { createReducer, on } from "@ngrx/store";
import { FeatureFlagModel } from "../models/featureFlag.model";

const INITIAL_STATE_FEATURE_FLAGS: FeatureFlagModel[] = [];

export const featureFlagsReducer = createReducer(
  INITIAL_STATE_FEATURE_FLAGS,
  on(ADD_FEATURE_FLAGS, (state, { flags }) => {
    const updatedState = state.map((featureFlag) => {
      const newFeatureFlag = flags?.find(
        (newFlag) => newFlag?.id === featureFlag?.id,
      );
      return newFeatureFlag
        ? { ...featureFlag, ...newFeatureFlag }
        : featureFlag;
    });

    const newFlags = flags?.filter(
      (flag) => !state?.some((featureFlag) => featureFlag?.id === flag?.id),
    );
    return [...updatedState, ...newFlags];
  }),
);
